<div
  class="relative bg-gray-50 min-h-screen w-screen flex items-center justify-center"
>
  <div
    class="top-0 fixed z-20 transition-all duration-200 ease-in-out w-[calc(100vw-16rem)]"
  >
    <app-auth-top-bar class=""></app-auth-top-bar>
  </div>

  <div class="auth-left max-lg:hidden z-10 w-1/2 h-screen relative overflow-hidden">
    <div class="auth-left-bg">
      <div class="auth-mesh auth-mesh-1"></div>
      <div class="auth-mesh auth-mesh-2"></div>
      <div class="auth-mesh auth-mesh-3"></div>
      <div class="auth-grid"></div>
      <div class="auth-grain"></div>
    </div>

    <div class="auth-left-content">
      <app-custom-carousel></app-custom-carousel>
    </div>

    <div class="auth-badge auth-badge-top">
      <span class="auth-badge-icon">
        <mat-icon>lock</mat-icon>
      </span>
      <div class="auth-badge-text">
        <strong>End-to-end encrypted</strong>
        <span>Session secured by Ngao</span>
      </div>
      <span class="auth-badge-pulse"></span>
    </div>

    <div class="auth-stat auth-stat-left">
      <div class="auth-stat-num">99.9<span>%</span></div>
      <div class="auth-stat-label">Uptime</div>
      <div class="auth-stat-bar"><span></span></div>
    </div>

    <div class="auth-stat auth-stat-right">
      <div class="auth-stat-num">500<span>+</span></div>
      <div class="auth-stat-label">Institutions</div>
      <div class="auth-stat-dots">
        <span></span><span></span><span></span><span></span>
      </div>
    </div>

    <div class="auth-ribbon">
      <mat-icon>verified</mat-icon>
      <span>Government&nbsp;·&nbsp;Secure&nbsp;·&nbsp;Scalable</span>
      <mat-icon>verified</mat-icon>
      <span>Government&nbsp;·&nbsp;Secure&nbsp;·&nbsp;Scalable</span>
    </div>

    <span class="auth-corner auth-corner-tl"></span>
    <span class="auth-corner auth-corner-br"></span>
  </div>

  <div
    class="bg-white w-full lg:w-1/2 h-screen overflow-auto rounded-xl md:py-7 p-5 md:px-[10vw] flex flex-col items-center justify-center relative"
  >
    <div
      class="absolute top-0 right-0 w-[25vw] h-[25vw] overflow-hidden"
    >
      <div
        class="absolute -top-[3vw] -right-[6vw] z-0 w-[20vw] h-[20vw] rounded-full bg-gradient-radial from-primary-300/80 via-primary-200 to-transparent backdrop-blur-sm blur-xl animate-gooey"
      ></div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
